import { Translation } from "i18n/config";
import { PricingTalentsTranslations } from "./typing";

export const PricingTalentsTexts: Translation<PricingTalentsTranslations> = {
	es: {
		titleSection:
			"Capta la atención de posibles socios o empleados, busca el mejor equipo ofreciendo acciones o dinero.",
		fourSlotsPerMonth: "4 Slots por mes",
		lookForCandidates: "Busca candidatos a través de nuestros tags: skills, universidad y sector económico.",
		speedUpLookUpOfCandidates: "Agiliza la busqueda con nuestros filtros de ofertas.",
		trackYourCandidates: "Realiza seguimiento de tus candidatos a través de los procesos de selección.",
	},
	en: {
		titleSection:
			"Capture the attention of potential partners or employees, look for the best team by offering shares or money.",
		fourSlotsPerMonth: "4 Slots per month",
		lookForCandidates: "Search for candidates through our tags: skills, university and economic sector.",
		speedUpLookUpOfCandidates: "Speed up your search with our offer filters.",
		trackYourCandidates: "Track your candidates through the selection processes.",
	},
	ca: {
		titleSection: "Capta l'atenció de possibles socis o empleats, cerca el millor equip oferint accions o diners.",
		fourSlotsPerMonth: "4 Slots por mes",
		lookForCandidates: "Busca candidatos a través de nuestros tags: skills, universidad y sector económico.",
		speedUpLookUpOfCandidates: "Agiliza la busqueda con nuestros filtros de ofertas.",
		trackYourCandidates: "Realitza seguiment dels teus candidats a través dels processos de selecció.",
	},
	pt: {
		titleSection:
			"Capte a atenção de potenciais parceiros ou funcionários, procure a melhor equipe oferecendo ações ou dinheiro.",
		fourSlotsPerMonth: "4 Slots por mês",
		lookForCandidates: "Pesquise candidatos através de nossas tags: habilidades, universidade e setor econômico.",
		speedUpLookUpOfCandidates: "Acelere a busca com nossos filtros de ofertas.",
		trackYourCandidates: "Acompanhe seus candidatos através dos processos de seleção.",
	},
};
